import { gql } from "@apollo/client";

export const GET_VERSION = gql`
  query {
    version
  }
`;
